import dayjs from "dayjs";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCatalogRequest,
} from "../../api";

const initialState = {
  catalog: [],
  catalogExport: null,
  getCatalogInProgress: false,
  getCatalogError: null,
  getCatalogExportInProgress: false,
  getCatalogExportError: null,
};

export const getCatalog = createAsyncThunk(
  "catalog/getCatalog",
  async (_, { rejectWithValue }) => {
	  console.log(_);
	try {
	  const { page, pageSize, search, sort } = _;
	  const response = await getCatalogRequest({
		page,
		pageSize,
		search,
		sort,
	  });
	  return response.data;
	} catch (error) {
		console.log(error);
	  return rejectWithValue(error.message);
	}
  },
);

export const getCatalogExport = createAsyncThunk(
  "catalog/getCatalogExport",
  async (_, { rejectWithValue }) => {
	try {
	  const { search, sort } = _;
	  const response = await getCatalogRequest({
		page: 1,
		search,
		sort,
		all: true
	  });
	  return response.data;
	} catch (error) {
	  return rejectWithValue(error.message);
	}
  },
);


export const catalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
	clearData(state) {
	  state.catalog = [];
	},
  },
  extraReducers: (builder) => {
	builder
	  .addCase(getCatalog.pending, (state) => {
		state.getCatalogInProgress = true;
		state.getCatalogError = null;
	  })
	  .addCase(getCatalog.fulfilled, (state, action) => {
	  	let { payload =[] } = action;
		let totalPages = 0;
		if(Array.isArray(payload) && payload.length > 0) {
			totalPages = payload[0].total_rows;
		}
		for(let row of payload) {
			row.key = `${row.UPC}_${row.Catalogue_Number}`;
		}  
		state.catalog = {data: payload, totalPages};  
		state.getCatalogInProgress = false;
		state.getCatalogError = null;
	  })
	  .addCase(getCatalog.rejected, (state, action) => {
		state.getCatalogInProgress = false;
		state.getCatalogError = action.payload;
	  })
	  
	  .addCase(getCatalogExport.pending, (state) => {
		state.getCatalogExport = null;
		state.getCatalogExportInProgress = true;
		state.getCatalogExportError = null;
		})
		.addCase(getCatalogExport.fulfilled, (state, action) => {
		let { payload =[] } = action;
		for(let row of payload) {
			row.UPC = ` ${row.UPC}`;
		}  
		state.catalogExport = payload;  
		state.getCatalogExportInProgress = false;
		state.getCatalogExportError = null;
		})
		.addCase(getCatalogExport.rejected, (state, action) => {
		state.getCatalogExportInProgress = false;
		state.getCatalogExportError = action.payload;
		})
  },
});

export const { clearData } = catalogSlice.actions;

// this is for configureStore
export default catalogSlice.reducer;
